import React from 'react';
import { useSelector } from 'react-redux';

export default function SearchContainer(props) {
  const currentMeetingRoomNameFilter = useSelector((state) => state.meetingRoomReducer.currentMeetingRoomNameFilter);

  const handleTypingEnter = (event) => {
    if (event.keyCode === 13) {
      // Cancel the default action, if needed
      event.preventDefault();
      props.onKeyUpHandler();
    }
  };

  const { ...rest } = props;
  return <input type="text" onKeyUp={handleTypingEnter} value={currentMeetingRoomNameFilter || ''} {...rest} />;
}
